module.exports = __webpack_public_path__ + "static/media/acheta_domesticus_001_APA.2798df79.mp3";